import { Col, Row } from "antd";
import moment from "moment";
import { Link } from "react-router-dom";
import { GITHUB, LINKEDIN, TWITTER } from "../App.constant";
import Victor from "../assets/images/Victor.svg";
import GithubSVG from "../assets/images/github.svg";
import LinkedinSVG from "../assets/images/linkedin.svg";
import TwitterSVG from "../assets/images/twitter.svg";
import stateWrapper from "../containers/provider";
import { useResponsive } from "../hooks/responsive";

const FooterBar = (props) => {
  const [
    isTabletOrMobileDevice,
    isTabletOrMobile,
    isBigScreen,
    isDesktopOrLaptop,
    isPortrait,
    isRetina,
    isTablet,
  ] = useResponsive();
  const year = moment().format("YYYY");
  
  return (
    <div className="footer">
      <div
        style={{
          width: "90%",
          padding: "20px",
          margin: "0 auto",
        }}
      >
        <Row align="middle" gutter={[16, 16]}>
          {/* Left - Branding */}
          <Col xs={24} sm={8}>
            <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
              <img src={Victor} style={{ width: 28, height: 28 }} alt="Vicks" />
              <div>
                <div style={{ fontSize: 13, fontWeight: "bold", color: "#FFF", fontFamily: "'Montserrat', sans-serif" }}>Vicks</div>
                <div style={{ fontSize: 10, color: "gray", fontFamily: "'Montserrat', sans-serif" }}>@{year} Victor Umesiobi</div>
              </div>
            </div>
          </Col>
          
          {/* Middle - Site Links */}
          <Col xs={24} sm={8}>
            <div style={{ display: "flex", justifyContent: isTabletOrMobileDevice ? "flex-start" : "center", gap: 20 }}>
              <Link to="/" style={{ color: "#B0B6C5", fontSize: 12, fontFamily: "'Montserrat', sans-serif", textDecoration: "none" }}>Home</Link>
              <Link to="/contact" style={{ color: "#B0B6C5", fontSize: 12, fontFamily: "'Montserrat', sans-serif", textDecoration: "none" }}>Contact</Link>
            </div>
          </Col>
          
          {/* Right - Social Icons */}
          <Col xs={24} sm={8}>
            <div style={{ display: "flex", justifyContent: isTabletOrMobileDevice ? "flex-start" : "flex-end", alignItems: "center", gap: 12 }}>
              <a target="_blank" rel="noopener noreferrer" href={LINKEDIN}>
                <img src={LinkedinSVG} style={{ width: 16, height: 16, opacity: 0.7 }} alt="LinkedIn" />
              </a>
              <a target="_blank" rel="noopener noreferrer" href={GITHUB}>
                <img src={GithubSVG} style={{ width: 16, height: 16, opacity: 0.7 }} alt="GitHub" />
              </a>
              {TWITTER && (
                <a target="_blank" rel="noopener noreferrer" href={TWITTER}>
                  <img src={TwitterSVG} style={{ width: 16, height: 16, opacity: 0.7 }} alt="Twitter" />
                </a>
              )}
            </div>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default stateWrapper(FooterBar);
